import { ComparatorEnum } from '../../../models/interface/comparator.enum';
import { PermissionExpressBasicOption } from '../keys/permissionExpressBasic.enum';
import { PermissionBaseType } from '../models/permissionBaseType.enum';
import { PermissionOperator } from '../models/permissionOperator.interface';
import { PermissionOption } from '../models/permissionOption.interface';

export const permissionExpressBasic: PermissionOption[] = [
  {
    code: 'P300',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_COMMON_LOGIN,
    permissions: ['express-basic.common.login'],
    comparator: ComparatorEnum.EXACT,
  },
  {
    code: 'P301',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_SERVICES_REQUEST_SERVICE,
    permissions: ['express-basic.services.requestService'],
    comparator: ComparatorEnum.STARTS_WITH,
  },
  {
    code: 'P301',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_SERVICES_MERCHANDISE,
    permissions: ['express-basic.services.requestService'],
    comparator: ComparatorEnum.STARTS_WITH,
  },
  {
    code: 'P301',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_SERVICES_PAYMENT,
    permissions: ['express-basic.services.requestService'],
    comparator: ComparatorEnum.STARTS_WITH,
  },
  { code: 'P302', option: PermissionExpressBasicOption.EXPRESS_BASIC_SERVICES_LOAD_STOP, permissions: ['express-basic.services.loadStop'] },
  { code: 'P303', option: PermissionExpressBasicOption.EXPRESS_BASIC_SERVICES_SCHEDULE, permissions: ['express-basic.services.schedule'] },
  { code: 'P304', option: PermissionExpressBasicOption.EXPRESS_BASIC_SERVICES_ADD_STOP, permissions: ['express-basic.services.addStop'] },
  {
    code: 'P305',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_SERVICES_ADD_ROUND_TRIP,
    permissions: ['express-basic.services.addRoundTrip'],
  },
  {
    code: 'P306',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_SERVICES_DETAIL,
    permissions: ['express-basic.services.detail'],
    comparator: ComparatorEnum.STARTS_WITH,
  },
  {
    code: 'P306',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_SERVICES_DETAIL_BY_SERVICEID,
    permissions: ['express-basic.services.detail'],
    comparator: ComparatorEnum.STARTS_WITH,
  },
  {
    code: 'P307',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_SERVICES_RATE,
    permissions: ['express-basic.services.rate'],
    comparator: ComparatorEnum.EXACT,
  },
  {
    code: 'P308',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_SERVICES_CANCEL,
    permissions: ['express-basic.services.cancel'],
    comparator: ComparatorEnum.EXACT,
  },
  {
    code: 'P309',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_PAYMENTMETHODS,
    permissions: ['express-basic.paymentMethods.hideDifferentPostpayment'],
  },
  {
    code: 'PXXX',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_PAYMENT_METHODS_CREDIT_CARDS_ON_POSTPAID,
    permissions: ['express-basic.paymentMethods.creditCardsOnPostpaid'],
  },
  {
    code: 'P310',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_SERVICES_EVIDENCES,
    permissions: ['express-basic.services.evidences'],
    comparator: ComparatorEnum.EXACT,
  },
  {
    code: 'P312-P318',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_SERVICES,
    permissions: ['express-basic.services.list', 'express-basic.historicServices.list'],
    comparator: ComparatorEnum.STARTS_WITH,
    operator: PermissionOperator.OR,
  },
  {
    code: 'P318',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_SERVICES_ACTIVE_LIST,
    permissions: ['express-basic.services.list'],
    comparator: ComparatorEnum.EXACT,
  },
  {
    code: 'P312',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_SERVICES_HISTORIC_LIST,
    permissions: ['express-basic.historicServices.list'],
    comparator: ComparatorEnum.EXACT,
  },

  {
    type: PermissionBaseType.FLAG,
    code: 'FXXX',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_FLAG_LIST_ADD_CREDIT_CARD_CO,
    permissions: ['express_basic_flag_list_add_credit_card_co'],
    country: 'CO',
  },
  {
    type: PermissionBaseType.FLAG,
    code: 'FXXX',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_FLAG_LIST_ADD_CREDIT_CARD_MX,
    permissions: ['express_basic_flag_list_add_credit_card_mx'],
    country: 'MX',
  },
  {
    type: PermissionBaseType.FLAG,
    code: 'FXXX',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_FLAG_PREPAID_CO,
    permissions: ['express_basic_flag_prepaid_co'],
    country: 'CO',
  },
  {
    type: PermissionBaseType.FLAG,
    code: 'FXXX',
    option: PermissionExpressBasicOption.EXPRESS_BASIC_FLAG_PREPAID_MX,
    permissions: ['express_basic_flag_prepaid_mx'],
    country: 'MX',
  },
];
